import React from 'react'
import FieldLabel from './FieldLabel';
import {Box, Typography } from '@mui/material';

export default function InfoField({ icon, label, value }) {
  return (
    <Box>
      <FieldLabel icon={icon}>{label}</FieldLabel>
      <Typography
        variant="body1"
        sx={{ fontWeight: 600, color: "text.primary", fontSize: 15 }}
      >
        {value || "—"}
      </Typography>
    </Box>
  );
}
